/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevCodeIcon20Light = forwardRef('DevCodeIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.974 2.658a.5.5 0 1 0-.949-.316l-5 15a.5.5 0 0 0 .95.316l5-15Z" }),
        React.createElement("path", { d: "M14.646 5.144a.5.5 0 0 1 .707 0l3.442 3.438a2 2 0 0 1 0 2.83l-3.442 3.439a.5.5 0 1 1-.707-.708l3.442-3.439a1 1 0 0 0 0-1.414l-3.442-3.44a.5.5 0 0 1 0-.706Z" }),
        React.createElement("path", { d: "M5.35 5.149a.5.5 0 0 1 0 .707l-3.437 3.44a1 1 0 0 0 0 1.414l3.438 3.44a.5.5 0 1 1-.707.706l-3.438-3.44a2 2 0 0 1 0-2.827l3.438-3.44a.5.5 0 0 1 .707 0Z" })));
});
